import * as React from 'react';
import '../css/multi-action.sass';
import MultiActionOption from './MultiActionOption';

export interface IMultiActionOption {
  id: string;
  name: string;
  label: string;
  onClick?: Function;
  href?: string;
  description?: string;
  image?: string;
}

interface MultiActionProps {
  options: IMultiActionOption[];
  theme?: 'night' | 'day';
}
export default function MultiAction(props: MultiActionProps) {
  return (
    <div>
      {props.options.map((option: IMultiActionOption) => (
        <MultiActionOption
          key={option.id}
          name={option.name}
          label={option.label}
          id={option.id}
          theme={props.theme}
          href={option.href}
          onClick={option.onClick}
          description={option.description}
          image={option.image}
        />
      ))}
    </div>
  );
}
